export default "__VITE_ASSET__218ab5e8__"